module.exports = __webpack_public_path__ + "static/img/product_2_1.dd49626.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/product_2_1.png
// module id = PLT7
// module chunks = 34